export const DATA_STATIC = {
    quantity_all:'13695', 
    density_min_all:'109', 
    density_max_all:'189', 
    norm_min_all:'0,19', 
    norm_max_all:'9,72',
}

